import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './CustomerPanelSideBar.scss';

const CustomerPanelSideBar = () => {
    const [isExpanded, setIsExpanded] = useState(true);

    const menuItems = [
        { 
            path: '/customer-panel/home', 
            name: 'Dashboard', 
            icon: <span className="material-symbols-outlined">dashboard</span> 
        },
        { 
            path: '/customer-panel/orders', 
            name: 'Orders', 
            icon: <span className="material-symbols-outlined">shopping_cart</span> 
        },
    ];

    return (
        <div className={`customer-panel-sidebar ${isExpanded ? 'expanded' : 'collapsed'}`}>
            <button 
                className="toggle-button"
                onClick={() => setIsExpanded(!isExpanded)}
                title={isExpanded ? "Collapse menu" : "Expand menu"}
            >
                <span className="material-symbols-outlined">
                    {isExpanded ? 'chevron_left' : 'chevron_right'}
                </span>
            </button>

            {/* <div className="sidebar-header">
                {isExpanded && <h2 className="logo">customer</h2>}
            </div> */}

            <nav className="customer-panel-sidebar-menu">
                {menuItems.map((item, index) => (
                    <NavLink 
                        key={index}
                        to={item.path}
                        className={({ isActive }) => 
                            `customer-panel-menu-item ${isActive ? 'active' : ''}`
                        }
                        end={item.path === '/customer-panel'}
                    >
                        <span className="icon">{item.icon}</span>
                        <span className="label" style={{
                            opacity: isExpanded ? 1 : 0,
                            transition: 'opacity 0.3s'
                        }}>
                            {item.name}
                        </span>
                        {!isExpanded && (
                            <div className="tooltip">
                                {item.name}
                            </div>
                        )}
                    </NavLink>
                ))}
            </nav>
        </div>
    );
};

export default CustomerPanelSideBar;